import { i18n } from "@/locales/settings";
import { LocalesFields } from "@/locales/translateInterface";

export const learningType = (item: string) => {
  if (item === "course" || item === "course2")
    return i18n.tc(LocalesFields.Course);
  if (item === "webinar") return i18n.tc(LocalesFields.Webinar);
  if (item === "video") return i18n.tc(LocalesFields.Record);
};
